import { formatEther, parseEther } from "@ethersproject/units"
import { useWeb3React } from "@web3-react/core"
import { AppBody, AppHeader } from "components/App"
import { AutoRow } from "components/Layout/Row"
import { FAST_INTERVAL } from "config/constants"
import { useTranslation } from "contexts/Localization"
import {useERC20, useLockContract, useTokenContract} from "hooks/useContract"
import { useSWRContract } from "hooks/useSWRContract"
import useTokenBalance from "hooks/useTokenBalance"
import { useEffect, useState } from "react"
import { useCurrencyBalance, useTokenBalances } from "state/wallet/hooks"
import Page from "views/Page"
import { getBalanceAmount, getBalanceNumber, getDecimalAmount } from "utils/formatBalance"
import {Button, Card, Heading, Table, Td, Th, Image, Flex, Text, OpenNewIcon, Link, Toggle} from "uikit"
import ApproveConfirmButtons from "components/ApproveConfirmButtons"
import ApprovalAction from "views/Pools/components/PoolCard/CardActions/ApprovalAction"
import Balance from "components/Balance"
import { GreyCard, LightGreyCard } from "components/Card"
import Toast from "components/Toast/Toast"
import { types } from "components/Toast/types"
import useToast from "hooks/useToast"
import useTokenAllowance from "hooks/useTokenAllowance"
import { useCurrency, useToken } from "hooks/Tokens"
import JSBI from "jsbi"
import { ApprovalState, useApproveCallback } from "hooks/useApproveCallback"
import { CurrencyAmount } from "sdk/entities/fractions/currencyAmount"
import {ETHER, TokenAmount, WETH} from "sdk"
import BigNumber from "bignumber.js"
import { Contract } from "@ethersproject/contracts"
import { Masterchef__factory, PnnDistributor__factory, PnnMasterChef__factory } from "config/abi/types"
import {getBscScanLink, getProviderOrSigner} from "utils"
import { useCurrentBlock } from "state/block/hooks"
import TableLoader from "components/TableLoader"
import { AutoColumn } from "components/Layout/Column"
import contracts from "config/constants/contracts"
import useActiveWeb3React from "hooks/useActiveWeb3React"
 import RcPagination from 'rc-pagination';
import 'rc-pagination/assets/index.css';
import { ethers } from 'ethers';
import {DEFAULT_TOKEN_DECIMAL} from "../../config";
import SearchInput from "../../components/SearchInput";
import FormInput from "../../components/FormInput";
import Select from "../../components/Select/Select";
import styled from "styled-components";
import PageHeader from "../../components/PageHeader";
import StyledInternalLink from "../../components/Links";
import {BIG_TEN} from "../../utils/bigNumber";
import 'react-calendar-datetime-picker/dist/index.css'
import DateInput from "../../components/DateInput";
import {getLockAddress} from "../../utils/addressHelpers";
import {MaxUint256} from "@ethersproject/constants";
import {getBep20Contract} from "../../utils/contractHelpers";
import {ToastDescriptionWithTx} from "../../components/Toast";
import {LIQUITY_TOKEN_DECIMAL} from "./SelfToken";

const LabelWrapper = styled.div`
  margin-bottom: 20px;
  width: 100%;
`

const TxnLink = styled(Link)`
  color: #E7BB4B;
  font-size: 12px;
  &:hover {
    text-decoration: none;
  }
`

const ToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: 3px;
  margin-bottom: 20px;
  ${Text} {
    margin-left: 8px;
  }
`

export default function SelfLock() {
    const { t } = useTranslation()
    const { account, library } = useWeb3React()
    const { chainId } = useActiveWeb3React();
    const {toastSuccess, toastError } = useToast()
    const lockAddress = getLockAddress();
    const lockContract = useLockContract();

    const [address,setAddress] = useState('');
    const [errorAddress,setErrorAddress] = useState(false);
    const [needApprove,setNeedApprove] = useState(false);
    const [isApproving,setIsApproving] = useState(false);
    const [isLoading,setIsLoading] = useState(false);
    const [isAnotherAddress,setIsAnotherAddress] = useState(false);
    const [isVest,setIsVest] = useState(false);
    const [owner,setOwner] = useState('');
    const [title,setTitle] = useState('');
    const [amount,setAmount] = useState('');
    const [useVest,setUseVest] = useState(false);
    const [errorLockUntil,setErrorLockUntil] = useState(false);
    const [lockUntil, setLockUntil] = useState(null);
    const [tgeDate,setTgeDate] = useState(null);
    const [errorTgeDate,setErrorTgeDate] = useState(false);
    const [tgePer,setTgePer] = useState('');
    const [cycleDay,setCycleDay] = useState('');
    const [cyclePer,setCyclePer] = useState('');

    const [tokenInfo,setTokenInfo] = useState({
        'name':'',
        'symbol':'',
        'decimals':0,
        'isLp':false,
        'show':false
    });

    const onChangeAddress = async (event: React.ChangeEvent<HTMLInputElement>) => {
        setAddress(event.target.value)
        try{
            const contract = getBep20Contract(event.target.value, getProviderOrSigner(library, account));
            const symbol = await contract.symbol();
            const name = await contract.name();
            const decimals = await contract.decimals();
            const allowanceAmount = await contract.allowance(account, lockAddress);
            setNeedApprove(!new BigNumber(allowanceAmount.toString()).gt(0));
            let isLp = false;
            if(name == 'Pancake LPs' && symbol == 'Cake-LP'){
                isLp = true;
            }
            if(name == 'W3swap LPs' && symbol == 'W3-LP'){
                isLp = true;
            }
            setErrorAddress(false);
            setTokenInfo({
                'name':name,
                'symbol':symbol,
                'decimals':decimals,
                'isLp':isLp,
                'show':true
            });
        }catch (e) {
            setNeedApprove(false);
            setErrorAddress(true);
            setTokenInfo({
                'name':'',
                'symbol':'',
                'decimals':0,
                'isLp':false,
                'show':false
            });
        }
    }

    const onChangeOwner = (event: React.ChangeEvent<HTMLInputElement>) => {
        setOwner(event.target.value)
    }

    const onChangeTitle = (event: React.ChangeEvent<HTMLInputElement>) => {
        setTitle(event.target.value)
    }

    const onChangeAmount = (event: React.ChangeEvent<HTMLInputElement>) => {
        setAmount(event.target.value)
    }

    const onChangeTgePer = (event: React.ChangeEvent<HTMLInputElement>) => {
        setTgePer(event.target.value)
    }

    const onChangeCycleDay = (event: React.ChangeEvent<HTMLInputElement>) => {
        setCycleDay(event.target.value)
    }

    const onChangeCyclePer = (event: React.ChangeEvent<HTMLInputElement>) => {
        setCyclePer(event.target.value)
    }

    const onChangeAnother = (isAnother) => {
        setIsAnotherAddress(isAnother)
    }

    const onChangeTgeDate = (dateObj) => {
        if(dateObj){
            const date = new Date(dateObj.year, dateObj.month - 1, dateObj.day, dateObj.hour, dateObj.minute);
            const timestamp = date.getTime();
            const dateNow = new Date().getTime();
            if(dateNow >= timestamp){
                setErrorTgeDate(true);
                setErrorLockUntil(true);
            }else{
                setErrorTgeDate(false);
                setErrorLockUntil(false);
            }
            setLockUntil(timestamp/1000)
            setTgeDate(timestamp/1000)
        }
    }

    const onChangeLockUntil = (dateObj) => {
       if(dateObj){
           const date = new Date(dateObj.year, dateObj.month - 1, dateObj.day, dateObj.hour, dateObj.minute);
           const timestamp = date.getTime();
           const dateNow = new Date().getTime();
           if(dateNow >= timestamp){
               setErrorTgeDate(true);
               setErrorLockUntil(true);
           }else{
               setErrorTgeDate(false);
               setErrorLockUntil(false);
           }
           setLockUntil(timestamp/1000)
           setTgeDate(timestamp/1000)
       }
    }

    const create = async () => {
        if(errorAddress){
            toastError(
                t('Invalid token'),
            )
            return;
        }
        if(isVest){
            if(errorTgeDate){
                toastError(
                    t('Unlock time needs to be after now'),
                )
                return;
            }
            let ownerAddress;
            if(isAnotherAddress){
                ownerAddress = owner;
            }else{
                ownerAddress = account;
            }
            const totalSuppolyReal = new BigNumber(amount).times(BIG_TEN.pow(new BigNumber(tokenInfo['decimals'].toString())));
            let descreption = {"l":title};
            let tagper = new BigNumber(tgePer).multipliedBy(100);
            let cycleday = new BigNumber(cycleDay).multipliedBy(86400);
            let cycleper = new BigNumber(cyclePer).multipliedBy(100);
            console.log('owner:'+ownerAddress+",token:"+address+',isLpToken:'+tokenInfo['isLp']+',amount:'+totalSuppolyReal+',tgeDate:'+tgeDate+
                ',tgeBps:'+tagper+',cycle:'+cycleday+',cycleBps:'+cycleper+',description:' +JSON.stringify(descreption))
            try{
                setIsLoading(true);
                const tx = await lockContract.vestingLock(ownerAddress,address,tokenInfo['isLp'],totalSuppolyReal.toString(),tgeDate,
                    tagper.toString(),cycleday.toString(),cycleper.toString(),JSON.stringify(descreption));
                const receipt = await tx.wait();
                setIsLoading(false);
                toastSuccess(t('Success'));
            }catch (e) {
                setIsLoading(false);
                toastError(
                    e.toString(),
                )
            }
        }else{
            if(errorLockUntil){
                toastError(
                    t('Unlock time needs to be after now'),
                )
                return;
            }
            let ownerAddress;
            if(isAnotherAddress){
                ownerAddress = owner;
            }else{
                ownerAddress = account;
            }
            const totalSuppolyReal = new BigNumber(amount).times(BIG_TEN.pow(new BigNumber(tokenInfo['decimals'].toString())));
            let descreption = {"l":title};

            console.log('owner:'+ownerAddress+",token:"+address+',isLpToken:'+tokenInfo['isLp']+',amount:'+totalSuppolyReal+',unlockDate:'+lockUntil+',description:'
                +JSON.stringify(descreption))
            try{
                setIsLoading(true);
                const tx = await lockContract.lock(ownerAddress,address,tokenInfo['isLp'],totalSuppolyReal.toString(),lockUntil,JSON.stringify(descreption));
                const receipt = await tx.wait();
                setIsLoading(false);
                toastSuccess(t('Success'));
            }catch (e) {
                toastError(
                    e.toString(),
                )
            }
        }
    }

    const approve = async () => {
        if(errorAddress){
            toastError(
                t('Invalid token'),
            )
            return;
        }
        setIsApproving(true);
        const contract = getBep20Contract(address, getProviderOrSigner(library, account));
        const tx = await contract.approve(lockAddress, MaxUint256)
        const receipt = await tx.wait()
        const allowanceAmount = await contract.allowance(account, lockAddress);
        setNeedApprove(!new BigNumber(allowanceAmount.toString()).gt(0));
        setIsApproving(false);
    }

    const canNext: () => boolean = () => {
        let can = false;
        if(address == ''){
            can = true;
        }

        if(title == ''){
            can = true;
        }

        if(amount == '0' || amount == ''){
            can = true;
        }

        if(lockUntil == null){
            can = true;
        }

        if(isVest){
            if(tgeDate == null){
                can = true;
            }

            if(tgePer == '0' || tgePer == ''){
                can = true;
            }

            if(cyclePer == '0' || cyclePer == ''){
                can = true;
            }

            if(cycleDay == '0' || cycleDay == ''){
                can = true;
            }
        }

        if(isAnotherAddress){
            if(owner == ''){
                can = true;
            }
        }

        return can;
    };

    return <>
        <Page style={{margin:0}}>
            <Card style={{ width: '100%', maxWidth: '663px',padding:'0rem 2rem' }}>
                <div style={{height:60}}/>
                <AutoRow justify="center" margin="0 0 1.2rem">
                    <Heading>{t("Create your lock")}</Heading>
                </AutoRow>
                <div style={{height:60}}/>
                <FormInput title={t('Token or LP Token address')} placeholder={t('Enter token or LP address')} isRequired={true} onChange={onChangeAddress}/>
                {errorAddress?<Text style={{marginBottom:20}} color="#f14668" fontSize="14px">
                    {t('Invalid token')}
                </Text>:<div/>}
                {tokenInfo['show']?
                <div style={{marginBottom:20}}>
                    <div style={{width:'100%',display:'flex',flexDirection:'row',alignItems:'space-between',justifyContent:'space-between'}}>
                        <Text>Name</Text>
                        <Text>{tokenInfo['name']}</Text>
                    </div>
                    <div style={{width:'100%',display:'flex',flexDirection:'row',alignItems:'space-between',justifyContent:'space-between'}}>
                        <Text>Symbol</Text>
                        <Text>{tokenInfo['symbol']}</Text>
                    </div>
                    <div style={{width:'100%',display:'flex',flexDirection:'row',alignItems:'space-between',justifyContent:'space-between'}}>
                        <Text>Decimals</Text>
                        <Text>{tokenInfo['decimals']}</Text>
                    </div>
                    <div style={{width:'100%',display:'flex',flexDirection:'row',alignItems:'space-between',justifyContent:'space-between'}}>
                        <Text>IsLp</Text>
                        <Text>{tokenInfo['isLp']?'true':'false'}</Text>
                    </div>
                </div>:
                    <div/>
                }

                <div style={{height:20}}/>
                <FormInput title={t('Amount')} placeholder={t('Enter amount')} isRequired={true} onChange={onChangeAmount}/>
                <div style={{height:20}}/>
                <ToggleWrapper>
                    <Toggle
                        id="staked-only-farms"
                        checked={isVest}
                        onChange={() => setIsVest(!isVest)}
                        scale="sm"
                    />
                    <Text small> {t('use vesting?')}</Text>
                </ToggleWrapper>
                <div style={{height:20}}/>
                {isVest?<div>
                    <DateInput title={t('TGE Date')} placeholder={t('Select')} isRequired={true} onChange={onChangeTgeDate}/>
                    {errorTgeDate?<Text style={{marginBottom:20}} color="#f14668" fontSize="14px">
                        {t('Unlock time needs to be after now')}
                    </Text>:<div/>}
                    <FormInput title={t('TGE Percent')} placeholder={'Ex:10'} isRequired={true} onChange={onChangeTgePer}/>
                    <FormInput title={t('Cycle (days)')} placeholder={t('Ex:10')} isRequired={true} onChange={onChangeCycleDay}/>
                    <FormInput title={t('Cycle Release Percent')} placeholder={t('Ex:10')} isRequired={true} onChange={onChangeCyclePer}/>
                    <div style={{marginBottom:40}}/>
                </div>:
                    <div>
                        <DateInput title={t('Lock until')} placeholder={t('Select')} isRequired={true} onChange={onChangeLockUntil}/>
                        {errorLockUntil?<Text color="#f14668" fontSize="14px">
                            {t('Unlock time needs to be after now')}
                        </Text>:<div/>}
                    </div>
                }
                <div style={{height:20}}/>
                <FormInput title={t('Title')} placeholder={t('Ex:My Lock')} isRequired={true} onChange={onChangeTitle}/>
                <div style={{height:20}}/>
                <ToggleWrapper>
                    <Toggle
                        id="staked-only-farms"
                        checked={isAnotherAddress}
                        onChange={() => onChangeAnother(!isAnotherAddress)}
                        scale="sm"
                    />
                    <Text small> {t('use another owner?')}</Text>
                </ToggleWrapper>
                {isAnotherAddress?<div>
                    <FormInput title={t('Owner')} showBottom={true} placeholder={t('Enter owner address')} isRequired={true} onChange={onChangeOwner}/>
                    <Text small style={{marginBottom:20}}> {t('the address you input here will be receive the tokens once they are unlocked')}</Text>
                </div>:<div/>}

                <div style={{height:40}}/>
                <div style={{display:'flex',flexDirection:'row',borderWidth:1,borderColor:'#fff'}}>
                    <Text style={{marginBottom:30}} color="#E7BB4B" fontSize="14px">
                        {t('Please exclude W3Lock lockup address:')}{getLockAddress()+'  '}{t('from fees, rewards, max tx amount to start locking tokens.We dont support rebase tokens.')}
                    </Text>
                </div>
                {needApprove?<Button disabled={canNext()} isLoading={isApproving} width="100%" onClick={() => approve()}>{isApproving?t('Approving'):t("Approve")}</Button>:
                    <Button disabled={canNext()} isLoading={isLoading} width="100%" onClick={() => create()}>{isLoading?t("Locking"):t("Lock")}</Button>}

                <div style={{height:80}}/>
            </Card>
        </Page >
    </>
}